export { DetailedMatchCard } from "./DetailedMatchCard";
